import { UtagActions, MetricsLinkEvent, LinkEvent } from '../../types/metrics';

interface EventParams {
  searchResultsTotal: number;
  jobLocationId: string;
  jobSearchPhrase: string;
  searchIsApproachable: boolean;
}

export const impressionLinkEvent: MetricsLinkEvent<EventParams> = {
  action: UtagActions.Link,
  getValue: ({ params, context }) => ({
    ...context,
    eventName: LinkEvent.TsWidgetBtnSeekMatchingCandidateImpression,
    ...params,
  }),
};

export const interactedLinkEvent: MetricsLinkEvent<EventParams> = {
  action: UtagActions.Link,
  getValue: ({ params, context }) => ({
    ...context,
    eventName: LinkEvent.TsWidgetBtnMatchingCandidateSeekInteracted,
    ...params,
  }),
};
